import { getAvatarLetters } from '@/utils/string';

import { AvatarProps } from './User.interface';

import { AvatarContainer, StyledAvatar } from './User.styled';

export function Avatar({ size, children, ...props }: AvatarProps) {
  const letters =
    typeof children === 'string' ? getAvatarLetters(children) : undefined;

  return (
    <AvatarContainer>
      <StyledAvatar size={size} {...props}>
        {letters}
      </StyledAvatar>
    </AvatarContainer>
  );
}
